// Shipping Vietnamese translations
export const shippingVi = {
  'add.prepaid.record': 'Thêm hồ sơ',
  'add.repair.record': 'Thêm Hồ Sơ Sửa Chữa',
  'add.shipping.price': 'Thêm Giá Vận Chuyển',
  'add.shipping.record': 'Thêm Hồ Sơ Vận Chuyển',
  'advance': 'Tạm Ứng',
  'advance.payment': 'Tạm Ứng',
  'auto.calculate.all.costs': 'Tính Phí Tự Động',
  'back.to.shipping': 'Quay Lại Vận Chuyển',
  'back.to.shipping.records': 'Quay Lại Hồ Sơ Vận Chuyển',
  'calculate.costs': 'Tính Phí',
  'confirm.delete.shipping.price': 'Bạn có chắc chắn muốn xóa giá vận chuyển này không? Hành động này không thể hoàn tác.',
  'create.shipping.record': 'Tạo Hồ Sơ Vận Chuyển',
  'delivery.note.image': 'Hình Ảnh Phiếu Giao Hàng',
  'edit.prepaid.record': 'Sửa hồ sơ tạm ứng',
  'edit.repair.record': 'Chỉnh Sửa Hồ Sơ Sửa Chữa',
  'edit.shipping.price': 'Chỉnh Sửa Giá Vận Chuyển',
  'edit.shipping.record': 'Chỉnh Sửa Hồ Sơ Vận Chuyển',
  'error.deleting.shipping.price': 'Lỗi khi xóa giá vận chuyển',
  'link.prepaid.record': 'Liên kết hồ sơ tạm ứng',
  'link.repair.receipt': 'Liên Kết Hoá Đơn Sửa Chữa',
  'linked.prepaid.records': 'Hồ sơ tạm ứng đã liên kết',
  'linked.repair.records': 'Hồ Sơ Sửa Chữa Đã Liên Kết',
  'no.prepaid.records.linked': 'Không có hồ sơ tạm ứng nào được liên kết',
  'no.repair.records.found': 'Không tìm thấy hồ sơ sửa chữa nào.',
  'no.repair.records.linked': 'Không có hồ sơ sửa chữa nào được liên kết',
  'no.shipping.records.found': 'Không tìm thấy hồ sơ vận chuyển nào.',
  'no.unlinked.prepaid.records': 'Không có hồ sơ tạm ứng chưa liên kết',
  'no.unlinked.repair.records': 'Không có hồ sơ sửa chữa chưa liên kết',
  'prepaid.amount': 'Số tiền tạm ứng',
  'prepaid.date': 'Ngày tạm ứng',
  'prepaid.records': 'Hồ sơ tạm ứng',
  'ready.to.calculate': 'Sẵn sàng tính toán tất cả các phí tự động',
  'recent.repairs': 'Sửa Chữa Gần Đây',
  'repair': 'Sửa Chữa',
  'repair.cost': 'Chi Phí Sửa Chữa',
  'repair.costs': 'Chi Phí Sửa Chữa',
  'repair.date': 'Ngày Sửa Chữa',
  'repair.records': 'Hồ Sơ Sửa Chữa',
  'repair.shop': 'Garage Sửa Chữa',
  'select.prepaid.record.to.link': 'Chọn hồ sơ tạm ứng để liên kết',
  'select.repair.record.to.link': 'Chọn hồ sơ sửa chữa để liên kết',
  'select.vehicle.date.province.first': 'Vui lòng chọn xe, ngày vận chuyển và tỉnh/thành trước',
  'select.vehicle.date.province.to.calculate': 'Chọn xe, ngày vận chuyển và tỉnh/thành để tính tất cả các phí tự động',
  'shipping.address': 'Địa Chỉ Giao Hàng',
  'shipping.cost': 'Chi Phí Vận Chuyển',
  'shipping.date': 'Ngày Vận Chuyển',
  'shipping.price.deleted.successfully': 'Xóa giá vận chuyển thành công',
  'shipping.prices': 'Giá Vận Chuyển',
  'shipping.prices.history': 'Lịch Sử Giá Vận Chuyển',
  'shipping.profit': 'Lợi Nhuận Vận Chuyển',
  'shipping.record': 'Hồ Sơ Vận Chuyển',
  'shipping.records': 'Hồ Sơ Vận Chuyển',
  'shipping.revenue': 'Doanh Thu Vận Chuyển',
  'total.prepaid.amount': 'Tổng số tiền tạm ứng',
  'total.repair.cost': 'Tổng Chi Phí Sửa Chữa',
  'total.repairs': 'Tổng Số Lần Sửa Chữa',
  'total.shipping.records': 'Tổng Số Hồ Sơ Vận Chuyển',
  'view.shipping.records': 'Xem Hồ Sơ Vận Chuyển',
  'will.calculate.driver.salary': 'Lương Tài Xế',
  'will.calculate.loading.fee': 'Phí Bốc Xếp',
  'will.calculate.rm2': 'Phí RM2',
  'will.calculate.shipping.cost': 'Phí Vận Chuyển',
  'will.calculate.toll.fee': 'Phí Cầu Đường',

  // Shipping Price by Capacity (Matrix)
  'shipping.price.matrix': 'Giá Vận Chuyển Theo Tải Trọng',
  'shipping.price.capacity.history': 'Lịch Sử Giá Vận Chuyển Theo Tải Trọng',
  'capacity': 'Tải Trọng',
  'all.capacities': 'Tất Cả Tải Trọng',
  'tons': 'T',
  'all.provinces': 'Tất Cả Tỉnh/Thành',
  'all.districts': 'Tất Cả Quận/Huyện',
  'location.type': 'Loại Địa Điểm',
  'reason.for.changes': 'Lý Do Thay Đổi',
  'enter.reason': 'Nhập lý do thay đổi giá...',
  'no.changes.to.save': 'Không có thay đổi để lưu',
  'changes.saved.successfully': 'Lưu thay đổi thành công!',
  'error.saving.changes': 'Lỗi khi lưu thay đổi',
  'confirm.discard.changes': 'Hủy tất cả thay đổi chưa lưu?',
  'discard.changes': 'Hủy Thay Đổi',
  'unsaved.changes': 'Thay đổi chưa lưu',
  'no.price.set': 'Chưa đặt giá (sẽ dùng giá tỉnh nếu có)',
  'no.data.found': 'Không tìm thấy dữ liệu. Thử thay đổi bộ lọc.',
  'view.history': 'Xem Lịch Sử',
  'old.price': 'Giá Cũ',
  'new.price': 'Giá Mới',
  'changed.by': 'Người Thay Đổi',
  'no.history.found': 'Không tìm thấy lịch sử',
  'refresh': 'Làm Mới',
  'created': 'Tạo Mới',
  'updated': 'Cập Nhật',
  'deleted': 'Đã Xóa',
  'price.by.capacity': 'Giá Theo Tải Trọng',

  // Shipping Price by Capacity Matrix - additional
  'base.price': 'Giá Cơ Bản',
  'base.price.explanation': 'Giá cơ bản (màu xanh nhạt) áp dụng cho tất cả tải trọng xe. Chỉnh sửa ô để tạo giá riêng theo tải trọng (màu trắng). Giá riêng sẽ được ưu tiên khi tính chi phí vận chuyển.',
  'how.it.works': 'Cách hoạt động',
  'using.base.price': 'Dùng giá cơ bản',
  'custom.override': 'Giá riêng',
  'no.base.prices.found': 'Không tìm thấy giá cơ bản. Vui lòng thêm địa điểm trong trang Giá Vận Chuyển trước.',

  // Shipping date warning
  'shipping.date.warning': 'Cảnh báo: Ngày vận chuyển ({shippingDate}) khác ngày hôm nay ({today}) hơn 1 ngày. AI có thể đọc sai ngày từ hình ảnh. Bạn có chắc ngày vận chuyển là đúng không?',
  'shipping.date.warning.title': 'Cảnh Báo Ngày Vận Chuyển',
  'shipping.date.confirm': 'Đúng, Ngày Chính Xác',
};
